import { Button, ConfigProvider, DatePicker, Select } from "antd";
import React from "react";
import { Views } from "react-big-calendar";

const options = [
  {
    label: "Calendar",
    title: "Calendar",
    options: [
      {
        value: Views.DAY,
        label: "Day",
      },
      {
        value: Views.WEEK,
        label: "Week",
      },
      {
        value: Views.MONTH,
        label: "Month",
      },
      {
        value: Views.AGENDA,
        label: "Agenda",
      },
    ],
  },
  {
    label: "Schedules",
    title: "Schedules",
    options: [
      {
        value: "Upcoming",
        label: "Upcoming",
      },
      {
        value: "Previous",
        label: "Previous",
      },
    ],
  },
];

const CalendarHeader = ({
  customView,
  setCustomView,
  onNextClick,
  onPrevClick,
  dateText,
  today,
  setDate,
}) => {
  return (
    <div className="bg-white p-16 border-bottom">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#0f6936",
            activeBg: "#0f6936",
            activeBorderColor: "#2e9245",
          },
        }}
      >
        <div className="flex-between">
          <div className="flex-row gap-2">
            <div
              className="cursor"
              onClick={() => {
                onPrevClick();
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/arrow-left.svg`}
                alt="left"
              />
            </div>
            <div
              className="cursor"
              onClick={() => {
                onNextClick();
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/arrow-right.svg`}
                alt="right"
              />
            </div>
            <div>
              {customView === Views.DAY || customView === Views.AGENDA ? (
                <DatePicker
                  value={dateText ? dateText : ""}
                  format={"D MMM YYYY"}
                  style={{ width: 140 }}
                  onChange={(value) => setDate(value?.toDate())}
                />
              ) : customView === Views.WEEK ? (
                <DatePicker
                  value={dateText ? dateText : ""}
                  format={"D MMM YYYY"}
                  style={{ width: 140 }}
                  onChange={(value) => setDate(value?.toDate())}
                />
              ) : (
                <DatePicker
                  value={dateText ? dateText : ""}
                  format={"MMM YYYY"}
                  style={{ width: 140 }}
                  onChange={(value) => setDate(value?.toDate())}
                />
              )}
            </div>
          </div>
          <div className="flex-row gap-2">
            <Button onClick={() => setDate(today)}>Today</Button>
            <Select
              defaultValue={customView}
              style={{
                width: 150,
              }}
              onChange={(value) => setCustomView(value)}
              options={options}
            />
          </div>
        </div>
      </ConfigProvider>
    </div>
  );
};

export default CalendarHeader;
